import { Box, Button, Card, Typography } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import { Colours } from "../assets/global/Theme-variable";

export default function LinkCard({ link }) {
  return (
    <Button
      sx={{
        width: "100%",
        // aspectRatio: 1 / 1,
        backgroundColor: link.name === "Support" ? "#2a9ec5" : "#DFF2F8",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        p: 2,
        mb: 2,
        borderRadius: 1,
        // "&::before": {
        //   display: "flex",
        //   padding: "100%",
        // },
      }}
      // elevation={3}
      onClick={link.onClick}
      component={motion.div}
      whilehover={{ scale: 2 }}
      whiletap={{ scale: 0.9 }}
    >
      {/* <Box
        sx={{
          borderRadius: 23,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        elevation={3}
      > */}
      <link.icon
        color={link.name === "Support" ? "white" : Colours.gsblue}
        size={link.name === "Support" ? 14 : 28}
      />
      {/* </Box> */}
      <Typography
        sx={{
          fontSize: link.name === "Support" ? 14 : 16,
          // paddingTop: 0,
          userSelect: "none",
          textAlign: "center",
          // lineHeight: 1,
          color: link.name === "Support" ? "white" : Colours.darkGrey,
          // mt: link.name === "Help" && 1,
        }}
      >
        {link.name}
      </Typography>
    </Button>
  );
}
